// extracted by mini-css-extract-plugin
export default {"objetGraphe":"ObjetGraphe_objetGraphe__1XQw-","FondImageGraphe":"ObjetGraphe_FondImageGraphe__SUmV1"};